import { render, staticRenderFns } from "./bind-google-code.vue?vue&type=template&id=a676e002&scoped=true&"
import script from "./bind-google-code.vue?vue&type=script&lang=js&"
export * from "./bind-google-code.vue?vue&type=script&lang=js&"
import style0 from "./bind-google-code.vue?vue&type=style&index=0&id=a676e002&lang=scss&scoped=true&"
import style1 from "./bind-google-code.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a676e002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a676e002')) {
      api.createRecord('a676e002', component.options)
    } else {
      api.reload('a676e002', component.options)
    }
    module.hot.accept("./bind-google-code.vue?vue&type=template&id=a676e002&scoped=true&", function () {
      api.rerender('a676e002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-account-management/bind-google-code.vue"
export default component.exports